import { NSlider } from "@/components/NSlider";
import { Editor_Words } from "@/utils/lang/editor";
import { chakra } from "@chakra-ui/react";
import { langStore, translate } from "@noli/business";
import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React from "react";

const IFidelity: React.FC<{
  // alias: string;
  value: number;
  setValue: (value: number) => void;
  className?: string;
}> = ({ value, setValue, className }) => {
  const lang = langStore.tgt;

  return (
    <NSlider
      className={classNames(className, "c-variation-strength")}
      label={translate(Editor_Words["fidelity"], lang)}
      onChange={(value) => setValue(value)}
      min={0}
      max={1}
      value={value}
    />
  );
};

export const Fidelity = chakra(observer(IFidelity));
